@if (loading$ | async) {
  <div class="flex flex-col gap-2.5">
    <p-skeleton width="100%" height="44px" />
    <p-skeleton width="100%" height="44px" />
    <p-skeleton width="100%" height="44px" />
    <p-skeleton width="100%" height="44px" />

    <p-skeleton width="100%" height="98px" />

    <p-skeleton width="100%" height="16px" styleClass="mb-2.5"/>

    <p-skeleton width="100%" height="40px"/>

  </div>
} @else {
  <form [formGroup]="feedbackForm" class="flex flex-col gap-2.5">
    <p-dropdown formControlName="subjectId" [readonly]="true" [options]="subjects" optionLabel="display" optionValue="value" placeholder="Тема обращения*" />
    <input type="text" pInputText formControlName="email" placeholder="Введите Email*" />
    <p-inputMask styleClass="w-full" [unmask]="true" mask="+7 (999) 999-99-99" formControlName="phone" placeholder="Введите номер телефона*" />
    <input type="text" pInputText formControlName="fullName" placeholder="Введите имя и фамилию*" />
    <textarea rows="5" pInputTextarea formControlName="body" class="!h-[98px]" [autoResize]="false" placeholder="Введите комментарий*"></textarea>
    <p-checkbox
      formControlName="agreeWithPersonalDataHandling"
      [binary]="true"
      label="Согласен на обработку персональных данных*"
    ></p-checkbox>
    <button type="submit" [disabled]="feedbackForm.invalid" (click)="sendFeedback()" pButton label="Отправить" class="p-button-s mt-2.5" [loading]="(loadingSend$ | async) || false"></button>
  </form>
}
